import { Component, OnInit, Input } from '@angular/core';
import { DialogService } from 'ng2-bootstrap-modal';
import { BcPropertySearchComponent } from './bc-property-search/bc-property-search.component';
import { BcVisitationComponent } from './bc-visitation/bc-visitation.component';
import { BcInsuranceModalComponent } from './bc-insurance-modal/bc-insurance-modal.component';
import { BcAccountClientService } from './service/bc-account-client.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { AccountClientDetailsService } from '../../account-client/service/account-client-edit/account-client-details.service';

@Component({
    selector: 'app-bc-account-client',
    templateUrl: './bc-account-client.component.html',
    styleUrls: ['./bc-account-client.component.scss'],
    providers: [
        BcPropertySearchComponent,
        BcInsuranceModalComponent,
        BcAccountClientService
    ]
})
export class BcAccountClientComponent implements OnInit, OnDestroy {


    @Input('client') client = [];
    @Input('profileUser') profileUser;

    public juridicalProposal: any[] = [];
    public proposalControl = []; // Receive data of proposals IDs and Status
    public proposalSubscription; // Control changes in Proposal
    public cobrancaSubcription;
    public permissoes: any[] = [];
    public enviandoSeguradora = false;
    public dataEnvioSeguradora: Date;
    public financialSummary: any = null;

    constructor(private dialogService: DialogService,
        private bcPropertySearchComponent: BcPropertySearchComponent,
        private bcAccountClientService: BcAccountClientService,
        private flashMessagesService: FlashMessagesService,
        private accountClientService: AccountClientDetailsService) { }

    ngOnInit() {
        this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];

        this.getBilllingInfos();
        this.proposalSubscription = this.bcAccountClientService.proposalChanged.subscribe(proposalChanged => {
            this.getBilllingInfos();
        });

        this.getFinancialSummary();
        this.cobrancaSubcription = this.accountClientService.cobrancaReload.subscribe(value => {
          this.getFinancialSummary();
        });
    }

    ngOnDestroy() {
        this.proposalSubscription.unsubscribe();
    }

    openSearchModal() {
        this.dialogService.addDialog(BcPropertySearchComponent, { clientObj: this.client }, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
    }

    openVisitationModal() {
        this.dialogService.addDialog(BcVisitationComponent, { clientObj: this.client }, { backdropColor: 'rgba(0, 0, 0, 0.5)' }).subscribe(result => {
            this.getFinancialSummary();
        });
    }

    openInsuranceModal() {
        this.dialogService.addDialog(BcInsuranceModalComponent, { clientObj: this.client }, { backdropColor: 'rgba(0, 0, 0, 0.5)' }).subscribe(result => {
            this.getFinancialSummary();
        });
    }

    getBilllingInfos() {
        this.bcAccountClientService.getBilllingInfos(this.client['ID']).subscribe(result => {
            if (result.Success) {
                this.proposalControl = result.Result;
                console.log("Controle das Propostas", this.proposalControl);
            } else {
                this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            console.log(error);
        });
    }

    sendToJuridicalProposal() {
        this.bcAccountClientService.sendToJuridical(this.client).subscribe(result => {
            if (result.Success) {

                this.juridicalProposal = result.Result;
                this.proposalControl['PropostaJuridicoID'] = result.Result.ID;
                this.bcAccountClientService.billingChaged.next();

                setTimeout(() => {
                    $('#accordionBCCliJuridical a.collapsed').trigger("click");
                    $('html, body').animate({
                        scrollTop: $('#accordionBCCliJuridical').offset().top
                    }, 500);
                }, 1000);

                this.flashMessagesService.show("Proposta de envio ao Jurídico iniciada", { cssClass: 'alert-success', timeout: 6000 });
            } else {
                this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            console.log(error);
        });
    }

    getFinancialSummary() {
        this.bcAccountClientService.getFinancialSummary(this.client['ID']).subscribe(result => {
            if (result.Success) {
                this.financialSummary = result.Result;
                $('html, body').animate({ scrollTop: $(".billing-tab").offset().top - 20 }, 500);
            } else {
                this.financialSummary = null;
                this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
            }
        }, error => {
            this.financialSummary = null;
            console.log(error);
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-account-client.component.ts